import axios from "axios";

const getFunctionsUrl = () => {
    let apiUrl;
    if (window.location.hostname === 'localhost') {
        apiUrl = "http://localhost:5001/chautarihomecare/us-central1/app"
    } else {
        apiUrl = "https://us-central1-chautarihomecare.cloudfunctions.net/app"
    }
    return apiUrl;
}
const Axios = axios.create({baseURL: getFunctionsUrl()});
export default Axios;